export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/da.lyaml"));
at({ "da": { "public": { "sampleString": "Eksempelstreng" } } });
};